import ExecAPI from 'appRoot/api/api';

export function GetSecretsList()
{
	return ExecAPI("SecretsManagerData/GetSecretsList");
}

export function GetSecretDetail(key)
{
	return ExecAPI("SecretsManagerData/GetSecretDetail", { key });
}

export function SaveSecret(oldKey, key, value)
{
	return ExecAPI("SecretsManagerData/SaveSecret", { oldKey, key, value });
}

export function DeleteSecret(key)
{
	return ExecAPI("SecretsManagerData/DeleteSecret", { key });
}

export function GetAgentAuthorization()
{
	return ExecAPI("SecretsManagerData/GetAgentAuthorization");
}

export function SetAgentAuthorization(agentId, authorized)
{
	return ExecAPI("SecretsManagerData/SetAgentAuthorization", { agentId, authorized });
}

export function DownloadSecretsJson()
{
	return ExecAPI("SecretsManagerData/DownloadSecretsJson");
}
